module.exports = __webpack_public_path__ + "img/IMG_9022_L_BlackMatted_MockedUp.85fca070.jpg";